import { Tooltip } from '@material-ui/core';
import React from 'react';

import { Div, Text } from '~/src/dash/publicaUI';
import { getColorTheme } from '~/src/dash/resellers/utils/importResellerConfig';

export const BetaTooltipIcon = () => {
  const betaTitle =
    'This feature is in beta. Contact your account manager if you are interested in testing this feature.';
  return (
    <Tooltip title={betaTitle}>
      <Div style={{ position: 'relative' }}>
        <Div
          style={{
            position: 'absolute',
            top: '-0.8em',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            padding: '0 4px',
            backgroundColor: getColorTheme('betaIconBackground'),
            boxShadow: '0px 1px 1px rgba(0, 0, 0, 0.1)',
          }}
        >
          <Text bold mini color={getColorTheme('betaIconText')}>
            BETA
          </Text>
        </Div>
      </Div>
    </Tooltip>
  );
};
